<app-header></app-header>

<!-- Hero Start -->
<section class="bg-half bg-light d-table w-100"
  style="background: url('../../../../../assets/images//background/abt-3.png') center center;">
  <div class="bg-overlay bg-overlay-white"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="page-next-level">
          <h1 class="title">{{'Home.Contact.ContactUs' | translate}}</h1>
          <div class="page-next">
            <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb bg-white rounded shadow mb-0">
                <li class="breadcrumb-item"><a href="#">{{'Home.Home' | translate}}</a> <i class="uil uil-angle-{{'dir-icon' | translate}} px-2"></i></li>
                <li class="breadcrumb-item active "><a href="#">{{'Home.Contact.ContactUs' | translate}}</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div> <!--end col-->
    </div><!--end row-->
  </div> <!--end container-->
</section><!--end section-->
<!-- Hero End -->

<!-- Shape Start -->
<div class="position-relative">
  <div class="shape overflow-hidden text-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!--Shape End-->



<!-- Start Contact -->
<section class="contact bg-white py-5 ">

  <div class="container">
    <div class=" content row ">

      <div class="col-md-6 p-5 bg-light">
        <div class="title-heading">
          <h1 class="mb-4 fw-bold">{{'Home.Contact.GetInTouch' | translate}}</h1>
          <p class="text-muted">
            {{ 'Home.StartWorking' | translate }} <span class="text-primary fw-bold">{{ 'Home.EasyKash' | translate}}</span>{{ 'Home.SeeEverythingDesc' | translate }}
          </p>
          <div class="d-flex contact-detail align-items-center mt-3">
            <div class="icon">
              <i class="uil uil-envelope me-3"></i>
            </div>
            <div class="flex-1">
              <h6 class="title fw-bold mb-0">{{'Home.Contact.Email' | translate}}</h6>
              <a href="javascript:void(0)" class="text-primary">info&#64;easykash.net</a>
            </div>
          </div>

          <div class="d-flex contact-detail align-items-center mt-3">
            <div class="icon">
              <i class="uil uil-phone me-3"></i>
            </div>
            <div class="flex-1">
              <h6 class="title fw-bold mb-0">{{'Home.Contact.Phone' | translate}}</h6>
              <a href="javascript:void(0)" class="text-primary">01285885966 - 01226486855</a>
            </div>
          </div>

        </div>
      </div><!--end col-->

      <div class="col-md-6 align-items-center p-5">
        <h3 class="mb-4 font-bold">{{'Home.Contact.SendUs' | translate}}</h3>

        <form name="myForm" [formGroup]="contactForm" (submit)="sendMessage(contactForm.value)" novalidate>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">{{'Home.Contact.Yourname' | translate}} <span class="text-danger">*</span></label>
                <div class="form-icon position-relative">
                  <i class="uil uil-user icons"></i>
                  <input name="name" id="name" type="text" class="form-control ps-5" placeholder="{{'Home.Contact.Name' | translate}} :" formControlName="name"
                  [ngClass]="formValidator.formErrors.name ? 'border-danger':''">
                  <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.name">
                    {{ formValidator.formErrors.name }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">{{'Home.Contact.YourEmail' | translate}} <span class="text-danger">*</span></label>
                <div class="form-icon position-relative">
                  <i class="uil uil-envelope  text-dark me-3  icons"></i>
                  <input name="email" id="email" type="email" class="form-control ps-5" placeholder="{{'Home.Contact.Email' | translate}} :" formControlName="email"
                  [ngClass]="formValidator.formErrors.email ? 'border-danger':''">
                  <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.email">
                    {{ formValidator.formErrors.email }}
                  </div>
                </div>
              </div>
            </div><!--end col-->

            <div class="col-12">
              <div class="mb-3">
                <label class="form-label">{{'Home.Contact.Subject' | translate}} <span class="text-danger">*</span></label>
                <div class="form-icon position-relative">
                  <i class="uil uil-book-alt icons"></i>
                  <input name="subject" id="subject" class="form-control ps-5" placeholder="{{'Home.Contact.Subject' | translate}}:" formControlName="subject"
                  [ngClass]="formValidator.formErrors.subject ? 'border-danger':''">
                  <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.subject">
                    {{ formValidator.formErrors.subject }}
                  </div>
                </div>
              </div>
            </div><!--end col-->

            <div class="col-12">
              <div class="mb-3">
                <label class="form-label">{{'Home.Contact.Comments' | translate}} <span class="text-danger">*</span></label>
                <div class="form-icon position-relative">
                  <i class="uil uil-comment icons clearfix"></i>
                  <textarea name="comments" id="comments" rows="4" class="form-control ps-5" placeholder="{{'Home.Contact.Message' | translate}} :" formControlName="message"
                  [ngClass]="formValidator.formErrors.message ? 'border-danger':''"></textarea>
                  <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.message">
                    {{ formValidator.formErrors.message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-grid">
                <button type="submit" class="btn btn-primary" [disabled]="contactForm.invalid">{{'Home.Contact.SendMessage' | translate}}</button>
              </div>
            </div><!--end col-->
          </div><!--end row-->
        </form>
      </div><!--end col-->


    </div><!--end row-->
  </div><!--end container-->
</section><!--end section-->
<!-- End contact -->

<recaptcha
[size]="'invisible'"
[hide]="false"
>
</recaptcha>

<app-footer></app-footer>
